import React, {useState, useEffect} from 'react';
import './HamburgerMenu.scss';
import {Link} from 'react-router-dom';

const multiLocationPages = [
    {'path': '/our-story', 'name': 'Our Story'},
    {'path': '/catering', 'name': 'Catering'},
    {'path': '/locations', 'name': 'Locations'},
    {'path': '/contact-us', 'name': 'Contact Us'},
    // {'path': '/wholesale', 'name': 'Wholesale'},
    {'path': '/menu', 'name': 'Menu'},
    {'path': '/order-online', 'name': 'Order Online'},
    {'path': '/gift-cards', 'name': 'Gift Cards'},
    {'path': '/events', 'name': 'Events'},
  ]


export default function HamburgerMenu() {
    const [showMenu, setShowMenu] = useState(false)
    useEffect(() => {
        const handleKeyDown = (e) => {
          if (e.key === 'Escape') {
            setShowMenu(false);
          }
        };
      
        if (showMenu) {
          document.addEventListener('keydown', handleKeyDown);
        } else {
          document.removeEventListener('keydown', handleKeyDown);
        }
      
        return () => {
          document.removeEventListener('keydown', handleKeyDown);
        };
      }, [showMenu]);
    function toggleMenu() {
        setShowMenu(!showMenu)
    }
    function handleClickOverlay () {
        setShowMenu(false)
    }
    return(
        <div className="hamburger-nav">
            <span onClick={toggleMenu} className="hamburger-icon">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Hamburger_icon.svg/64px-Hamburger_icon.svg.png" alt="show site navigation" />
            </span>


            {showMenu ? <div onClick={handleClickOverlay} className="overlay-menu-content">
                {multiLocationPages.map((item, index) => {
                    
                    return (
                        <div key={index} className="menu-item">
                            <Link to={item.path} onClick={toggleMenu}>{item.name}</Link>
                        </div>
                    )
                })}
            </div> : null}
        </div>
    )
}